import { Component, OnInit} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AuthenticationTokenStorageService } from 'app/services';
@Component({
  selector: 'app-data-studio-report-component',
  templateUrl: './data-studio-report.component.html',
  styleUrls: ['./data-studio-report.component.scss'],
})
export class DataStudioReportComponent implements OnInit {

  customerId: number | null = null;
  iFrameSrcUrl: SafeResourceUrl | null = null;
   constructor(
    private sanitizer: DomSanitizer,
    private readonly storageService: AuthenticationTokenStorageService
  ) {}

  ngOnInit(): void {
    const { customerId } = this.storageService.getLoggedUser();
    this.customerId = customerId;

    const params = JSON.stringify({
      // eslint-disable-next-line @typescript-eslint/naming-convention
      data_work_input_customer_id: customerId,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      data_state_input_customer_id: customerId,
    });

    this.iFrameSrcUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      `https://datastudio.google.com/embed/reporting/b0a705ff-4efd-4933-b0c8-ad16361a0215/page/rNK6C?params=${
      encodeURIComponent(params)
    }`);
  }
}
